"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSignupStatsResponse = exports.SignupTierInfo = void 0;
const zod_1 = require("zod");
exports.SignupTierInfo = zod_1.z.object({
    name: zod_1.z.string(),
    signupOrder: zod_1.z.number(),
    freeDays: zod_1.z.number(),
    includesCoaching: zod_1.z.boolean(),
});
exports.GetSignupStatsResponse = zod_1.z.object({
    totalSignups: zod_1.z.number(),
    currentTier: zod_1.z
        .object({
        name: zod_1.z.string(),
        minSignups: zod_1.z.number(),
        maxSignups: zod_1.z.number().nullable(),
        freeDays: zod_1.z.number(),
        includesCoaching: zod_1.z.boolean(),
    })
        .nullable(),
});
